import classNames from 'classnames';
import React, { useState } from 'react';
import { Form, Offcanvas } from 'react-bootstrap';

import { extractDataAutomationId, filterMetadata } from 'root/widgets/utils';

import { ContactType } from 'root/symbiosis-widgets';

import './contact-agent-sheet.scss';
import { ContactAgentSheetProps } from './types';

const ContactAgentSheet: React.FC<ContactAgentSheetProps> = ({
  className,
  consent,
  contactChannels,
  metadata,
  ...props
}) => {
  const [isConsentChecked, setConsentChecked] = useState(consent?.isChecked || false);

  const renderIcon = (type: ContactType | undefined, icon: string) => {
    switch (type) {
      case ContactType.WHATSAPP: {
        return <img src={icon} alt="whatsapp" />;
      }
      case ContactType.LINE: {
        return <img src={icon} alt="line" />;
      }
      default:
        return <i className={classNames('pgicon', icon)} />;
    }
  };

  const handleConsentCheckChange = () => {
    if (consent?.onCheckChange) {
      consent.onCheckChange(!isConsentChecked);
    }
    setConsentChecked(!isConsentChecked);
  };

  return (
    <Offcanvas
      className={classNames('contact-agent-sheet-root', className)}
      {...filterMetadata(metadata)}
      {...extractDataAutomationId(metadata)}
      placement="bottom"
      {...props}
    >
      <Offcanvas.Body>
        {consent && (
          <div className="contact-agent-sheet-header">
            {consent.hasCheck ? (
              <Form.Check
                id="contact-agent-consent-checkbox"
                className="contact-agent-consent-checkbox"
                type="checkbox"
                label={consent.text}
                checked={isConsentChecked}
                onChange={handleConsentCheckChange}
              />
            ) : (
              <p>{consent.text}</p>
            )}
          </div>
        )}
        <div className={classNames('contact-agent-sheet-body', { 'with-consent': Boolean(consent) })}>
          {contactChannels.map(({ icon, text, onClick, type, ...linkProps }) => {
            const handleChannelClick = () => {
              if (onClick) {
                onClick(isConsentChecked);
              }
            };

            return (
              <a key={icon} onClick={handleChannelClick} {...linkProps}>
                {renderIcon(type, icon)}
                {text}
              </a>
            );
          })}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ContactAgentSheet;
